<template>
    <div v-if="required">
        <div class="timesheets-required hidden-mobile">
            <h1>You Have {{ required_amount }} Timesheets Outstanding</h1>
            <p>You must submit your timesheets for any projects and hours spent working.</p>
            <a :href="timesheetsUrl">Log Hours</a>
        </div>
        <div class="hidden-desktop dashboard-component-icon">
            <h2>Timesheets</h2>
            <a :href="timesheetsUrl"><i class="fa fa-clock-o"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props:['timesheetsUrl'],
        data() {
            return {
                timesheets: [],
                loaded:false
            }
        },
        computed: {
            required: function(){
                return Object.keys(this.timesheets).length > 1
            },
            required_amount: function(){
                return Object.keys(this.timesheets).length;
            }
        },
        watch: {},
        methods: {
            getTimesheets() {
                this.timesheets = [];

                var that = this;

                axios.get(appUrls.timesheets.index)
                    .then(function (response) {
                        that.timesheets = response.data.meta.required_dates;
                        that.loaded = true;
                    });
            }
        },
        mounted() {
            this.getTimesheets();
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/setup';
    .dashboard-component-icon{
        background-color:#ED7003;
    }
    .timesheets-required {
        @include clearfix();
        background-color: #ED7003;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;

        h1{
            color:#FFF;
        }
        a{
            padding: 0.5em 0.8em;
            background-color: #FFF;
            border-radius: $standardBorderRadius;
            color: #Ed7003;
            margin: 0.2em 0 0 0;
            display: inline-block;
            text-decoration: none;
            transition:all 0.1s ease-in-out;
            &:hover{
                background-color: #ffefe4;
            }
        }
    }
</style>
